import React from 'react';
import { Alert, Box, CircularProgress, Stack } from '@mui/material';
import { useGetUserImportQuery } from '../../api/userImportsApi';
import { UserImportReportHeader } from './UserImportReportHeader';
import { UserImportReportTimes } from './UserImportReportTimes';
import { UserImportStatusAlert } from './UserImportStatusAlert';
import { UserImportProgress } from './UserImportProgress';
import { UserImportCounts } from './UserImportCounts';
import { UserImportReportTabs } from './UserImportReportTabs';

/**
 * One user import's results report, kept live from Firestore (getUserImport) so the admin
 * can watch it run or come back later. Each part reads the import itself: the heading (file,
 * status, Import another file), when it started and finished, a banner while it waits or
 * when it failed, progress while it runs, the created / skipped / failed counts, then the
 * Results and Log tabs with their downloads. The admin also gets a notification when it
 * finishes.
 */
export const UserImportReport = ({ importId }) => {
	const { data: userImport, isLoading, isError } = useGetUserImportQuery(importId);

	if (isLoading) {
		return (
			<Box display='flex' justifyContent='center' py={4}>
				<CircularProgress />
			</Box>
		);
	}
	if (isError || !userImport) {
		return <Alert severity='error'>Could not load this import.</Alert>;
	}

	return (
		<Stack spacing={2}>
			<UserImportReportHeader importId={importId} />
			<UserImportReportTimes importId={importId} />
			<UserImportStatusAlert importId={importId} />
			<UserImportProgress importId={importId} />
			<UserImportCounts importId={importId} />
			<UserImportReportTabs importId={importId} />
		</Stack>
	);
};
